<div class="chart-heading">

  <div class="chart-headline">
    Verbrauchsübersicht
  </div>

  <div>
    <time-range-selector
      (timeRangeChange)="onTimeRangeChanged($event)">
    </time-range-selector>
  </div>

  @if (totalConsumption !== null) {
    <div class="heading-consumption">
      <span class="consumption-label">Verbrauch ausgewählter Zeitraum</span>
      <span class="consumption-value">{{ formatConsumption(totalConsumption) }} kWh</span>
    </div>
  }

  <div class="heading-download">
    <button class="download-button" mat-icon-button (click)="exportCsv.emit()">
      <img src="assets/images/download.svg" alt="Download" />
    </button>
  </div>


</div>






























<!--  <div class="heading-timespan">-->
<!--    <mat-tab-group (selectedTabChange)="onTabChange($event)">-->
<!--      <mat-tab id="day" label="Tag"></mat-tab>-->
<!--      <mat-tab id="week" label="Woche"></mat-tab>-->
<!--      <mat-tab id="month" label="Monat"></mat-tab>-->
<!--      <mat-tab id="year" label="Jahr"></mat-tab>-->
<!--      <mat-tab id="custom">-->
<!--        <ng-template mat-tab-label>-->
<!--          <mat-date-range-input [rangePicker]="picker" class="inline-range-input">-->
<!--            <input matStartDate placeholder="Start date">-->
<!--            <input matEndDate placeholder="End date">-->
<!--          </mat-date-range-input>-->
<!--          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>-->
<!--          <mat-date-range-picker #picker></mat-date-range-picker>-->
<!--        </ng-template>-->

<!--        &lt;!&ndash; Optional content inside the tab panel &ndash;&gt;-->
<!--        <div class="tab-content">-->
<!--          <p>Benutzerdefinierter Zeitraum gewählt:</p>-->
<!--          <p>{{ dateRange.start | date:'shortDate' }} – {{ dateRange.end | date:'shortDate' }}</p>-->
<!--        </div>-->
<!--      </mat-tab>-->
<!--    </mat-tab-group>-->

<!--  </div>-->


<!--  <div class="heading-timespan">-->
<!--    <mat-tab-group (selectedTabChange)="onTabChange($event)">-->
<!--      <mat-tab id="day" label="Tag"></mat-tab>-->
<!--      <mat-tab id="week" label="Woche"></mat-tab>-->
<!--      <mat-tab id="month" label="Monat"></mat-tab>-->
<!--      <mat-tab id="year" label="Jahr"></mat-tab>-->
<!--      <mat-tab id="custom" label="Definieren">-->
<!--        <ng-container *ngIf="showCalendar">-->
<!--          <mat-calendar-->
<!--            [selected]="timeSelection.date"-->
<!--            (selectedChange)="onDateChange($event)">-->
<!--          </mat-calendar>-->
<!--        </ng-container>-->
<!--      </mat-tab>-->
<!--    </mat-tab-group>-->

<!--</div>-->
